import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CampaignType } from '@modules/campaigns/models/campaign.model';

export interface SlimWorkflow {
  id: string;
  name: string;
  type?: CampaignType;
  status: string;
}

@Injectable({ providedIn: 'root' })
export class WorkflowSharedService {
  private workflowsSubject = new BehaviorSubject<SlimWorkflow[]>([]);
  workflows$ = this.workflowsSubject.asObservable();

  setWorkflows(workflows: SlimWorkflow[]) {
    this.workflowsSubject.next(workflows);
  }

  getWorkflowMap(): Map<string, string> {
    return new Map(this.workflowsSubject.getValue().map((w) => [w.id, w.name]));
  }
}
